export var ItemShareability;
(function (ItemShareability) {
    ItemShareability[ItemShareability["ITEM_NOT_SHAREABLE"] = 0] = "ITEM_NOT_SHAREABLE";
    ItemShareability[ItemShareability["ITEM_PARTIALLY_SHAREABLE"] = 1] = "ITEM_PARTIALLY_SHAREABLE";
    ItemShareability[ItemShareability["ITEM_FULLY_SHAREABLE"] = 2] = "ITEM_FULLY_SHAREABLE";
    ItemShareability[ItemShareability["ITEM_FULLY_SHAREABLE_STACKING"] = 3] = "ITEM_FULLY_SHAREABLE_STACKING";
})(ItemShareability || (ItemShareability = {}));
export var ItemDeclarations;
(function (ItemDeclarations) {
    ItemDeclarations[ItemDeclarations["DECLARE_PURCHASES_TO_TEAMMATES"] = 0] = "DECLARE_PURCHASES_TO_TEAMMATES";
    ItemDeclarations[ItemDeclarations["DECLARE_PURCHASES_IN_SPEECH"] = 1] = "DECLARE_PURCHASES_IN_SPEECH";
    ItemDeclarations[ItemDeclarations["DECLARE_PURCHASES_TO_SPECTATORS"] = 2] = "DECLARE_PURCHASES_TO_SPECTATORS";
})(ItemDeclarations || (ItemDeclarations = {}));
export var ItemDisassembleRule;
(function (ItemDisassembleRule) {
    ItemDisassembleRule[ItemDisassembleRule["DOTA_ITEM_DISASSEMBLE_NEVER"] = 0] = "DOTA_ITEM_DISASSEMBLE_NEVER";
    ItemDisassembleRule[ItemDisassembleRule["DOTA_ITEM_DISASSEMBLE_ALWAYS"] = 1] = "DOTA_ITEM_DISASSEMBLE_ALWAYS";
})(ItemDisassembleRule || (ItemDisassembleRule = {}));
//# sourceMappingURL=item.js.map